/**
 * Cart รายการที่กำลังเพิ่มใน Add Items Dialog (ເພີ່ມລາຍການ)
 * ใช้ sync ไปยัง Customer Display เพื่อให้จอลูกค้าแสดงรายการที่กำลังจะเพิ่ม
 */

import type { CartItem } from "../context/CartContext";

const STORAGE_KEY = "posCustomerDisplayTempCart";
const EVENT_NAME = "customer-display-temp-cart-updated";

export function getCustomerDisplayTempCart(): CartItem[] | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as CartItem[];
    if (Array.isArray(parsed)) return parsed;
  } catch {
    localStorage.removeItem(STORAGE_KEY);
  }
  return null;
}

export function setCustomerDisplayTempCart(items: CartItem[]): void {
  if (typeof window === "undefined") return;
  if (items.length === 0) {
    clearCustomerDisplayTempCart();
    return;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function clearCustomerDisplayTempCart(): void {
  if (typeof window === "undefined") return;
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function addCustomerDisplayTempCartListener(
  callback: () => void,
): () => void {
  const handler = () => callback();
  const storageHandler = (e: StorageEvent) => {
    if (e.key === STORAGE_KEY) callback();
  };
  window.addEventListener(EVENT_NAME, handler);
  window.addEventListener("storage", storageHandler);
  return () => {
    window.removeEventListener(EVENT_NAME, handler);
    window.removeEventListener("storage", storageHandler);
  };
}
